
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toolkits/games/[slug]",
      function () {
        return require("private-next-pages/toolkits/games/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/toolkits/games/[slug]"])
      });
    }
  